// ST-1705 -Claude- Route guard for the business portal.
import { Navigate, useLocation } from 'react-router-dom';
import { hasAnyPermission, policyForPath } from './permissions';
import { useAdminAuth } from './useAdminAuth';

export function ProtectedAdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, user } = useAdminAuth();
  const loc = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/business/login" state={{ from: loc.pathname }} replace />;
  }
  const policy = policyForPath(loc.pathname);
  if (!hasAnyPermission(user, policy)) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
}
